import { LazyLoadEvent } from 'primeng/api';
import { AnnouncementDetails } from '../shared/models/announcement-detail-model';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { ModerationStatusEnum } from '../shared/enums/announcement-enums';
import { AuthService } from '@admin/core/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'hr-announcement-details',
  templateUrl: './announcement-details.component.html',
  styleUrls: ['./announcement-details.component.less'],
  standalone: false,
})
export class AnnouncementDetailsComponent implements OnInit {
  @Input('announcementDetails')
  public announcementDetails: AnnouncementDetails;
  public statusEnum: any;

  public changeLogColor(status) {
    if (status === this.statusEnum.Approved) {
      return LogColors.Approved;
    } else if (status === this.statusEnum.Rejected) {
      return LogColors.Rejected;
    } else if (status === this.statusEnum.Pending) {
      return LogColors.Pending;
    } else if (status === this.statusEnum.Overriden) {
      return LogColors.Overriden;
    }
  }

  onLoginAsCustomer(customerId: number){
    this.authService.loginAsCustomer(customerId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      //display message
    });
  }

  constructor(
    private authService: AuthService,
    private destroyRef: DestroyRef
  ) {
    this.statusEnum = ModerationStatusEnum;
  }

  ngOnInit() {}
}
export enum LogColors {
  Approved = '#85C226',
  Rejected = '#F00',
  Pending = '#F7CD3A',
  Overriden = '#FF6500',
}
